<template>
  <section class="text-float full-page-section">
    <div class="content">
      <div v-html="stringh"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TextFloat',
  data () {
    return {
      page: {}
    }
  },
  props: {
    stringh: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .text-float {
    .columnify {
      margin-left: -5vw;
      margin-right: -5vw;
      text-align: left;
      column-gap: 40px;
      columns: 100px 3;
      @media only screen and (max-width: 1430px) {
        columns: 100px 2;
        padding: 10px;
      }
      @media only screen and (max-width: 600px) {
        columns: 100px 1;
        padding: 30px;
      }
      p {
        margin-top: 0;
      }
    }
  }
</style>
<style scoped lang="scss">
  .text-float {
  }
</style>
